import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import * as subscriptionPackActions from '../../../store/subscription-packs'
import Y from '../../../y18n'

import SkeletonTable from '../../../common/skeleton-table'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import TableBody from '@material-ui/core/TableBody'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import TableToolbarFilter from '../../../common/tableToolbars/table-toolbar-filter'

import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'
import InfoIcon from '@material-ui/icons/Info'

import Styles from '../../../common/styles'

const mapStateToProps = state => ({
  subscriptionPacks: state.subscriptionPacks
})

const mapDispatchToProps = dispatch => ({
  subscriptionPackActions: bindActionCreators(subscriptionPackActions, dispatch)
})

class SubscriptionPacksTable extends Component{
  componentDidMount () {
    this.props.subscriptionPackActions.getSubscriptionPacks()
  }

  componentWillUnmount () {
    this.props.subscriptionPackActions.clearSubscriptionPacks()
  }

  // add filter management
  render(){
    const { subscriptionPacks, subscriptionPackActions, classes } = this.props

    return (
      <div>
      
      {/*<TableToolbar store={subscriptionPacks} storeActions={subscriptionPackActions} title={Y`subscription_packs`} />*/}

      <TableToolbarFilter title={'subscription_packs'}
                          onAdd={subscriptionPackActions.setNew}
                          /*onSearch={() => console.log('NOT YET IMPLEMENTED!')}
                          filterProps={[
                            {label: Y`subpack_filter_tags`,
                             placeholder: Y`subpack_filter_tags`,
                             select: true,
                             value: '',
                             selections: [{label: 'TO BE EDITED', value:'0'},
                                          {label: 'MyTag1', value:'1'},
                                          {label: 'MyTag2', value:'2'}],
                             onChange: () => {console.log('NOT YET IMPLEMENTED!')}
                            },
                            {label: Y`subpack_filter_endpoints_only`,
                             placeholder: Y`subpack_filter_endpoints_only`,
                             value: '',
                             select: true,
                             selections: [{label: Y`subpack_filter_endpoints_only`, value:'true'},
                                          {label: Y`subpack_filter_endpoints_all`, value:'false'}],
                             onChange: () => {console.log('NOT YET IMPLEMENTED!')}
                             
                            },
                            {label: Y`subpack_filter_lower_data_limit`,
                             placeholder: Y`MyPlaceHolder`,
                             value: 0,
                             type: 'number',
                             onChange: () => {console.log('NOT YET IMPLEMENTED!')}
                            },
                            {label: Y`subpack_filter_upper_data_limit`,
                             placeholder: Y`MyPlaceHolder`,
                             value: 0,
                             type: 'number',
                             onChange: () => {console.log('NOT YET IMPLEMENTED!')}
                            },
                          ]}*/
                          />

        <div className={classes.tableWrapper}>
          <Table className={'striped'}>
            <TableHead>
                <TableRow>
                  <TableCell/>
                  <TableCell>
                    <TableSortLabel>
                      {Y`subpack_name`}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel>
                      {Y`subpack_data`}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel>
                      {Y`subpack_downgrade_to`}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel>
                      {Y`subpack_upgrade_to`}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel>
                      {Y`subpack_edited_date`}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel>
                      {Y`subpack_edited_by`}
                    </TableSortLabel>
                  </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
              {subscriptionPacks.loading ? (
                <SkeletonTable rows={15} cols={9} />) : (
                  (subscriptionPacks && subscriptionPacks.items) ? (
                  subscriptionPacks.items.map(subPack => this.renderSubscriptionPack(subPack))) :
                  ""
                )
              }

            </TableBody>
            
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={subscriptionPacks.table.itemCount}
                  rowsPerPage={subscriptionPacks.table.rows}
                  page={subscriptionPacks.table.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
            
          </Table>
        </div>
      </div>
    )
  }

  // TODO allow for desc && asc sorting
  renderSubscriptionPack = (subscriptionPack) => {

    if(!subscriptionPack) return null

    return (
      <TableRow key={subscriptionPack.id}>
        <TableCell>
          <IconButton title={Y`subpack_edit_icon`} onClick={() => this.editDialog(subscriptionPack)}>
            <EditIcon/>
          </IconButton>
          <IconButton title={Y`subpack_view_logs_icon`} onClick={() => this.viewEvents(subscriptionPack)}>
            <InfoIcon/>
          </IconButton>
        </TableCell> 
        <TableCell>{subscriptionPack.name}</TableCell>
        <TableCell>{subscriptionPack.data}</TableCell>
        <TableCell>{subscriptionPack.downgradeTo ? subscriptionPack.downgradeTo.name : Y`subpack_not_connected`}</TableCell>
        <TableCell>{subscriptionPack.upgradeTo ? subscriptionPack.upgradeTo.name : Y`subpack_not_connected`}</TableCell>
        <TableCell>{subscriptionPack.edited.split('T')[0]}</TableCell>
        <TableCell>{subscriptionPack.editedBy}</TableCell>
      </TableRow>
    )
  }

  handleChangePage = (event, page) => {
    if(!page)
      page = 0
    this.props.subscriptionPackActions.setPage(page)
    this.props.subscriptionPackActions.getSubscriptionPacks()
  }

  handleChangeRowsPerPage = event => {
    this.props.subscriptionPackActions.setRows(event.target.value)
    this.props.subscriptionPackActions.getSubscriptionPacks()
  }

  editDialog = subscriptionPack => {
    this.props.subscriptionPackActions.setActive(subscriptionPack)
    this.props.subscriptionPackActions.toggleDialog('edit')
  }

  viewEvents = subscriptionPack => {
   this.props.subscriptionPackActions.setActive(subscriptionPack)
   this.props.subscriptionPackActions.getSubscriptionPackEvents() 
   this.props.subscriptionPackActions.toggleDialog('events')
  }
}

SubscriptionPacksTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionPacksTable)
export default withStyles(Styles)(SubscriptionPacksTable)


// WEBPACK FOOTER //
// ./src/pages/subscription-packs/containers/subscription-packs-table.js